import { Stack } from "expo-router";

// Nested stack so the podcast list (`index`) and detail (`[podcastId]`) both
// render inside the (tabs) group, preserving the navigation rail on web and
// the bottom tab bar on native when drilling into a podcast.
const PodcastsLayout = () => {
	return (
		<Stack
			screenOptions={{
				headerShown: false,
				contentStyle: { flex: 1 },
			}}
		/>
	);
};

export default PodcastsLayout;
